import {React, useState, useEffect} from 'react'
import './homes.css'
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import {Button,Modal,ModalHeader} from 'reactstrap'
import { useNavigate } from 'react-router-dom';
export default function Login() {
        const [email, setEmail] = useState('');
        const [password, setPassword] = useState('')
        const [submitText, setSubmittext] = useState('Sign in')
        const navigate = useNavigate()
        const [modal, setModal] = useState(false);
    
    
        const login =async()=>{
            if(email && password){
                setSubmittext('Please wait...');
                const res = await fetch('https://panel.yunshuglobal.com:3073/api/login',{
                    method:"POST",
                    headers:{
                        "Content-Type":"application/json"
                    },
                    body:JSON.stringify({email,password}),
                    credentials:"include"
    
                })
                const data = await res.json();
                const {Login, exists} = data;
                if(Login == true && exists){
                    toast.success('Login successful');
                    setSubmittext('Sign in')
                    setEmail('')
                    setPassword('')
                    navigate('/')
    
                }
                else if(exists == false && Login ==  false){
                    toast.error('Account does not exist')
                    setSubmittext('Sign in')

                }
                else if(exists == true && Login == false){
                    toast.error('Incorrect email/password combination')
                    setSubmittext('Sign in')
                }
    
            }
            else{
                toast.error('All fields are required')
            }
        }

        const signup=()=>{
        navigate('/register')
    }

    const toggle=()=>{
        setModal(!modal)
    }


  return (
    <div>
    <ToastContainer />
        <div className="registerContainer">
           
            <div className="leftContainer">
            <div className="container">
                <img src="sautilogo.png" className='loginLogo' alt="" />
                <h2>Welcome to MUSTECH NETWORK LTD</h2>
                <p>Sign in to continue to dashboard</p>
                <div className="inputEntries">
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" onChange={(e)=>{setEmail(e.target.value)}} >
                        <Form.Control  className='inputSearch'   type="text" placeholder="Email" value={email} />
                    </FloatingLabel>
                    
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Password" onChange={(e)=>{setPassword(e.target.value)}} >
                        <Form.Control  className='inputSearch'   type="password" placeholder="Password" value={password} />
                    </FloatingLabel>


                    <Button color='success' onClick={login} className='btnSubmit'>{submitText}</Button>
                    <p style={{color:'blue',marginTop:'3%',cursor:'pointer'}} onClick={signup}>Don't have an account? Create a free account</p>
                    <p style={{color:'blue',cursor:'pointer'}} onClick={toggle}>Forgot password?</p>
                    
                </div>

            </div>
                

            </div>
            <div className="rightContainer">
                <img src="sautibanner.jpg" alt="" className='bannerImage' />
            </div>
            
        </div>

        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader>Reset password request</ModalHeader>
            <div className="modalContainer">
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" onChange={(e)=>{setEmail(e.target.value)}} >
                <Form.Control  className='inputSearch'   type="text" placeholder="Enter your Email" value={email} />
            </FloatingLabel>
            <Button color='success' >Request reset</Button>
            </div>
        </Modal>
    </div>
  )
}
